import React, { useRef, useState } from 'react';
import DropdownStyled from './bundle.esm2.js';
import Overlay from './Overlay/bundle.esm.js';
import { defaultFunction } from '../../utils/bundle.esm2.js';

const Dropdown = (props) => {
  const { overlay, children, target = ["click"], className = "" } = props;
  const { position = "left", width, showDropdown } = props;
  const { isFixed = false, backdropConfig } = props;
  const dropdownRef = useRef(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const showLocalOverlay = typeof showDropdown !== "undefined" ? showDropdown : showOverlay;
  const onMouseEnter = target.includes("hover") ? () => setShowOverlay(true) : defaultFunction;
  const onMouseLeave = target.includes("hover") ? () => setShowOverlay(false) : defaultFunction;
  const onClick = target.includes("click") ? () => setShowOverlay((prev) => !prev) : defaultFunction;
  const onFocus = target.includes("focus") ? () => setShowOverlay(true) : defaultFunction;
  const onBlur = target.includes("focus") ? () => setShowOverlay(false) : defaultFunction;
  return /* @__PURE__ */ React.createElement(DropdownStyled, {
    className: `Dropdown ${className}`,
    onClick,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur,
    ref: dropdownRef
  }, children, showLocalOverlay ? /* @__PURE__ */ React.createElement(Overlay, {
    parentRef: dropdownRef,
    position,
    width,
    target,
    isFixed,
    backdropConfig
  }, overlay) : null);
};
Dropdown.defaultProps = {
  className: "",
  target: ["click"],
  position: "left"
};

export { Dropdown as default };
//# sourceMappingURL=bundle.esm.js.map
